import { AppThunkAction } from '../reducers';

// services
import * as Services from '../../services/Contract.IAImport.Service';

// models
import { NewContractIAImportProcess, ContractIAImportProcess } from '../../models/Entities/Contracts/ContractIAImportProcess';
import { ErrorType } from '../../models/HttpError';

// actions
import * as Actions from '../actions';

type KnownAction =
	| Actions.ContractIAImport.ContractIAImportCreateRequestAction
	| Actions.ContractIAImport.ContractIAImportCreateSuccessAction
	| Actions.ContractIAImport.ContractIAImportCreateFailureAction
	| Actions.ContractIAImport.ContractIAImportGetLastRequestAction
	| Actions.ContractIAImport.ContractIAImportGetLastSuccessAction
	| Actions.ContractIAImport.ContractIAImportGetLastFailureAction;

const CreateImportContractProcess = (
	newProcess: NewContractIAImportProcess
): AppThunkAction<KnownAction> => async (dispatch, getState) => {
	const state = getState();
	const token: string | null = state?.oidc?.user?.access_token ? state.oidc.user.access_token : null;

	if (token === null) {
		dispatch({
			type: 'CONTRACT_IAIMPORT_CREATE_FAILURE',
			error: {
				ErrorCode: 401,
				ErrorMessage: 'Not authorized',
				Errors: []
			}
		});
		return;
	}

	dispatch({ type: 'CONTRACT_IAIMPORT_CREATE_REQUEST', newProcess });

	try {
		Services.CreateImportContractProcess(newProcess, token)
			.then((process: ContractIAImportProcess) => {
				dispatch({
					type: 'CONTRACT_IAIMPORT_CREATE_SUCCESS',
					process
				});
			})
			.catch((error: ErrorType) =>
				dispatch({
					type: 'CONTRACT_IAIMPORT_CREATE_FAILURE',
					error
				})
			);
	} catch (error) {
		console.log(error);
	}
};

const GetLastImportContractProcess = (
	contractId: number
): AppThunkAction<KnownAction> => async (dispatch, getState) => {
	const state = getState();
	const token: string | null = state?.oidc?.user?.access_token ? state.oidc.user.access_token : null;

	if (token === null) {
		dispatch({
			type: 'CONTRACT_IAIMPORT_GETLAST_FAILURE',
			contractId,
			error: {
				ErrorCode: 401,
				ErrorMessage: 'Not authorized',
				Errors: []
			}
		});
		return;
	}

	dispatch({ type: 'CONTRACT_IAIMPORT_GETLAST_REQUEST', contractId });

	try {
		Services.GetLastImportContractProcess(contractId, token)
			.then((process: ContractIAImportProcess | null) => {
				dispatch({
					type: 'CONTRACT_IAIMPORT_GETLAST_SUCCESS',
					contractId,
					process: process ?? null
				});
			})
			.catch((error: ErrorType) =>
				dispatch({
					type: 'CONTRACT_IAIMPORT_GETLAST_FAILURE',
					contractId,
					error
				})
			);
	} catch (error) {
		console.log(error);
	}
};

export const actionCreators = {
	CreateImportContractProcess,
	GetLastImportContractProcess,
};

